import { cn, useBreakpoints } from '@jobcost-monorepo/utils';
import { ReactElement } from 'react';
import { LogoImage } from '../../..';
import LogoImageMini from '../../../atoms/Logo/LogoImageMini';

interface Props {
  position: 'left' | 'center';
  children: ReactElement;
}

const AuthLayout: React.FC<Props> = ({ position, children }) => {
  const { isSmall } = useBreakpoints();

  const getAlignment = () => {
    if (position === 'left')
      return (
        <>
          <div
            className={cn(
              'flex flex-col justify-center items-center left-0 h-full bg-white dark:bg-dark ',
              isSmall ? 'min-w-full px-8' : 'w-[30%] min-w-fit px-20',
            )}
          >
            <div className="sm:w-full sm:max-w-md">
              <LogoImage className="mx-auto h-14 w-auto fill-black dark:fill-white" />
            </div>

            {children}
          </div>
          {!isSmall && (
            <div className="w-[70%] flex items-center justify-center">
              <LogoImageMini className="h-80 w-80 fill-white" />
            </div>
          )}
        </>
      );
    return (
      <div className="bg-white dark:bg-dark py-10 px-10 rounded-3xl flex flex-col self-center">
        <div className="sm:w-full sm:max-w-md">
          <LogoImage className="mx-auto h-14 w-auto fill-black dark:fill-white" />
        </div>
        {children}
      </div>
    );
  };

  return (
    <div className="flex justify-center bg-gradient-45- from-purple to-pink h-[calc(100dvh)] w-screen text-black dark:text-white">
      {getAlignment()}
    </div>
  );
};

export default AuthLayout;
